import { Button } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import { CalendarToday } from '@material-ui/icons';
import * as React from 'react';

import type { User } from 'v2/interfaces/user';

import { getConfig } from './config';
import { useStyles } from './styles';

declare global {
  const SimplybookWidget: any;
}

interface IProps {
  user: User;
}

async function loadScript() {
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://widget.simplybook.me/v2/widget/widget.js';
    script.type = 'text/javascript';
    script.async = true;
    script.onload = () => {
      resolve();
    };
    script.onerror = (err) => reject(err);

    document.head.appendChild(script);
  });
}

function Consultancy({ user }: IProps) {
  const classes = useStyles();

  React.useEffect(() => {
    const loadedScript = async () => {
      await loadScript();
      new SimplybookWidget(getConfig(user.wallet?.id));
    };
    loadedScript();
  }, []);

  if (!user || !user?.wallet) return null;

  return (
    <>
      <Card elevation={0} square className={classes.card}>
        <div className={classes.cardContainer}>
          <img src='/img/icon-rocket.svg' alt='Icone E-mail' />
          <div className={classes.textContainer}>
            <Typography color='inherit' gutterBottom component='span' className={classes.fontTitleStyle}>
              Precisa de visão estratégica?
            </Typography>
            <Typography color='textSecondary' variant='subtitle1' component='span' className={classes.fontDescriptionStyle}>
              Nossos analistas te guiam com insights e soluções da plataforma.
            </Typography>
          </div>
        </div>
        <Button className={classes.button} id='schedule-btn'>
          <CalendarToday />
          Agendar consultoria
        </Button>
      </Card>
    </>
  );
}

export { Consultancy };
